import { ChartSubType, ChartType } from '../../proto/generated/chart'
import { SeriesGroup } from '../home'
import { DrawingSettingsMap } from '../../components/chartV2/drawingTools/drawing.interface'

export interface PlotOptions {
    series: number[],
    referenceSeries?: number[],
    title: string
    code?: string,
    color?: string // in hex code
    thickness?: number,
    type: 'HISTOGRAM' | 'LINE' | 'AREA'
    subType?: ChartSubType,
    offset?: number
    display?: 'NONE',
    labels?: string[],
    withBreaks?: boolean,
    lineStyle?: 'Solid' | 'Dotted' | 'Dashed' | 'LargeDashed' | 'SparseDotted',
    isHline?: boolean
}

export interface DrawOptions {
    data: any,
    title: string,
    type: keyof DrawingSettingsMap
    code?: string
    settings?: Record<string, unknown>
}

export interface HLineOptions {
    price: number
    title: string
    color?: string,
    thickness?: number,
    lineStyle?: 'Solid' | 'Dotted' | 'Dashed' | 'LargeDashed' | 'SparseDotted'
    display?: 'NONE',
}

export interface LineOptions {
    color?: string
    title: string
    dataPoints: {
        startTime: number
        endTime: number
        val: number
    }[]
    /** Shows the level name in the label. */
    showLabels?: boolean
    /** Shows the level price in the label. */
    showPrices?: boolean
    labelsPosition?: 'Left' | 'Right'
    /** Line width in CSS px. */
    lineWidth?: number
    /** The data points are the full set to draw; without it they are merged into the lines already drawn. */
    complete?: boolean
}

export interface FillOptions {
    seriesA: number[]
    seriesB: number[]
    title: string
    color?: string
}

export interface PaneData {
    id: string
    grps: SeriesGroup[]
    primary: boolean
}

export interface ChartTypeInfo {
    type: ChartType
    chartUpdate: boolean
}

export enum ChartLineStyle {
    "SOLID" = 0,
    "DOTTED" = 1,
    "DASHED" = 2,
    "LARGEDASHED" = 3,
    "SPARSEDOTTED" = 4
}